import { Component, OnInit, Input } from '@angular/core';
import { FiltratedObjetives, Antecedente } from '../../../../api/interfaces/register';
import { AllAchievements} from '../../../../api/interfaces/user';
import { MobileDetectorService } from '../../../../services/mobileDetector/mobile-detector.service';


@Component({
  selector: 'app-background-objetives',
  templateUrl: './background-objetives.component.html',
  styleUrls: ['./background-objetives.component.scss']
})
export class BackgroundObjetivesComponent implements OnInit {

  @Input('allAchievements') allAchievements: AllAchievements;
  @Input('objetives') objetives: FiltratedObjetives;
  @Input('antecedente') antecedente: Antecedente[];
  @Input('showMarcasObjetivos') showMarcasObjetivos: boolean;
  @Input('showAntecedentes') showAntecedentes: boolean;
  class: string = "flexEvenlyWrap";
  isMobile: boolean = false;
  constructor(
    private mobileDetectorService: MobileDetectorService,
  ) { }

  ngOnInit(): void {
    this.isMobile = this.mobileDetectorService.isMobile();
    if(this.showMarcasObjetivos && !this.showAntecedentes) {
      this.class = "flexEvenlyWrapLeft";
    }
  }

}
